'use strict';

import { cn_element } from "../model/cn_element";

//***********************************************************************************
//***********************************************************************************
//**** cn_svg_context : contains all the informations to know what to display and how.
//***********************************************************************************
//***********************************************************************************

export class cn_svg_context {
    constructor() {
        /** @type {function(cn_element): boolean} */
        this._custom_draw_filter = function (element) { return true; };

        this.textures_per_element = new Map();

        this.texture_line_threshold = 20;
    }

    /**
     * Sets the draw filter function
     * @param {function(cn_element): boolean} f
     */
    set_custom_draw_filter(f) {
        this._custom_draw_filter = f;
    }

    /**
     * Returns the draw filter function
     * @return {function(cn_element): boolean}
     */
    get_custom_draw_filter() {
        return this._custom_draw_filter;
    }

    /**
     * Checks if a given element needs to be drawn
     * @param {cn_element} elt
     * @returns {boolean}
     */
    draw_filter(elt) {
        if (!this._custom_draw_filter) return true;
        return this._custom_draw_filter(elt);
    }

    get_textures_per_element(element_id) {
        return this.textures_per_element.get(element_id) || [];
    }
}

